import prestashop from 'prestashop';
import ScrollSmooth from 'scroll-smooth';

export default class Soledis {
  constructor() {
    this.version = '1.0.0';
  }

  init() {

    const scrollSmooth = new ScrollSmooth();
    this.scrollSmooth = scrollSmooth;

    //Custom sticky (suite pb checkout)
    let lastScrollPosition = window.scrollY;
    const scrollDirectionThreshold = 5;
    const hideHeaderOffset = 270; //Le header ne se cache qu'à partir de cette position de scroll

    window.addEventListener('DOMContentLoaded', () => {
      stickyHeader();
    });
    window.addEventListener('resize', () => {
      stickyHeader();
    });
    window.addEventListener('scroll', () => {
      stickyHeader(true);
    });

    function stickyHeader(detectScrollDirection = false) {
      const header = document.getElementById("header");
      if (!header) return;

      const headerHeight = header.offsetHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;
      const currentScrollPosition = Math.max(window.scrollY, 0);

      // Vérifie si la page est plus grande que la hauteur de la fenêtre pour éviter l'effet yoyo
      if (pageHeight > windowHeight + headerHeight) {
        if (currentScrollPosition > 0) {
          header.classList.add("is-sticky");

          if (detectScrollDirection) {
            const scrollDelta = currentScrollPosition - lastScrollPosition;

            if (header.classList.contains("is-open") || currentScrollPosition <= hideHeaderOffset) {
              header.classList.remove("is-hidden");
              lastScrollPosition = currentScrollPosition;
            } else if (scrollDelta > scrollDirectionThreshold) {
              header.classList.add("is-hidden");
              lastScrollPosition = currentScrollPosition;
            } else if (scrollDelta < -scrollDirectionThreshold) {
              header.classList.remove("is-hidden");
              lastScrollPosition = currentScrollPosition;
            }
          }

          const marginTop = headerHeight + 73; //On ajout 73 pour le .header-before
          document.body.style.marginTop = `${marginTop}px`;
        } else {
          header.classList.remove("is-sticky", "is-hidden");
          document.body.style.marginTop = '0px';
          lastScrollPosition = 0;
        }
      } else {
        // Empêche l'activation du sticky si la page est trop courte
        header.classList.remove("is-sticky", "is-hidden");
        document.body.style.marginTop = '0px';
      }
    }

    const headerTop = document.querySelector('.sld-js-header-top');

    if (headerTop !== null) {
      scrollSmooth.eventClick(headerTop);
    }

    const disableEventProductVariant = () => {
      const btnVariants = document.querySelectorAll('.product-variant__button');

      if (btnVariants.length > 0) {
        btnVariants.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
          });
        });
      }
    };

    disableEventProductVariant();

    prestashop.on('updatedProduct', () => {
      disableEventProductVariant();
    });
  }
}
